import React from "react";
import { useMemo } from "react";
import { useSelector } from "react-redux";

export function HBLForm() {
    
    let hblConfig = useSelector(state => state.donation.hblConfig)
    
    return useMemo(() => {
        return <div>
            <form id="payment_form" action={process.env.REACT_APP_HBL_POST_URL} method="post">
                <input type="hidden" name="access_key" value={hblConfig.access_key} />
                <input type="hidden" name="profile_id" value={hblConfig.profile_id} />
                <input type="hidden" name="transaction_uuid" value={hblConfig.transaction_uuid} />

                <input type="hidden" name="signed_field_names" value={hblConfig.signed_field_names} />
                <input type="hidden" name="unsigned_field_names" />
                <input type="hidden" name="signed_date_time" value={hblConfig.signed_date_time} />
                <input type="hidden" name="locale" value={hblConfig.locale} />
                <input type="hidden" name="transaction_type" value={hblConfig.transaction_type} size="25" />
                <input type="hidden" name="reference_number" value={hblConfig.reference_number} size="25" />
                <input type="hidden" name="amount" value={hblConfig.amount} size="25" />
                <input type="hidden" name="currency" value={hblConfig.currency} size="25" />

                <input type="hidden" name="payment_method" value={hblConfig.payment_method} size="25" />
                <input type="hidden" name="card_type" value={hblConfig.card_type} size="25" />
                <input type="hidden" name="card_number" value={hblConfig.card_number} size="25" />
                <input type="hidden" name="card_expiry_date" value={hblConfig.card_expiry_date} size="25" />
                <input type="hidden" name="card_cvn" value={hblConfig.card_cvn} size="25" />

                <input type="hidden" name="bill_to_forename" value={hblConfig.bill_to_forename} size="25" />
                <input type="hidden" name="bill_to_surname" value={hblConfig.bill_to_surname} size="25" />
                <input type="hidden" name="bill_to_email" value={hblConfig.bill_to_email} size="25" />
                <input type="hidden" name="bill_to_address_line1" value={hblConfig.bill_to_address_line1} size="25" />
                <input type="hidden" name="bill_to_address_city" value={hblConfig.bill_to_address_city} size="25" />
                <input type="hidden" name="bill_to_address_postal_code" value={hblConfig.bill_to_address_postal_code} size="25" />
                <input type="hidden" name="bill_to_address_state" value={hblConfig.bill_to_address_state} size="25" />
                <input type="hidden" name="bill_to_address_country" value={hblConfig.bill_to_address_country} size="25" />

                <input type="hidden" name="bill_to_phone" value={hblConfig.bill_to_phone} size="25" />
                <input type="hidden" name="consumer_id" value={hblConfig.consumer_id} size="25" />

                <input type="hidden" name="customer_ip_address" value={hblConfig.customer_ip_address} size="25" />
                <input type="hidden" name="recurring_amount" value={hblConfig.recurring_amount} size="25" />
                <input type="hidden" name="recurring_frequency" value={hblConfig.recurring_frequency} size="25" />
                <input type="hidden" name="recurring_start_date" value={hblConfig.recurring_start_date} size="25" />
                <input type="hidden" name="recurring_number_of_installments" value={hblConfig.recurring_number_of_installments} size="25" />

                <input type="hidden" name="override_backoffice_post_url" value={hblConfig.override_backoffice_post_url} size="25" />
                <input type="hidden" name="override_custom_cancel_page" value={hblConfig.override_custom_cancel_page} size="25" />
                <input type="hidden" name="override_custom_receipt_page" value={hblConfig.override_custom_receipt_page} size="25" />
                <input type="hidden" name="signature" value={hblConfig.signature} />
                <input type="hidden" name="merchant_defined_data1" value={'WC'} />

            </form>
        </div>
    }, [hblConfig])
}